module.exports = __webpack_public_path__ + "img/20200215103340_ynmed.38522600.jpg";